<template>
  <div>
    <div class="logo py-5 text-center">
      <v-img
        :src="logoUrl"
        :width="logoWidth"
        contain
        style="display:inline-block"
      />
    </div>
    <div class="text-center shape-bg">
      <v-carousel
        class="slider"
        v-model="carouselModel"
        light
        hide-delimiter-background
        :height="carouselHeight"
        :show-arrows="false"
      >
        <v-carousel-item
          v-for="(item, i) in items"
          :key="i"
        >
          <div class="px-5 carousel-item">
            <v-img
              :src="item.src"
              :width="carouselImgWidth"
              style="display:inline-block"
            />

            <div class="headline mt-4 carousel-item__header">
              <strong>{{ item.title }}</strong>
            </div>

            <div class="body-1 copy mt-5 carousel-item__body text--primary">
              {{ item.body }}
            </div>
          </div>
        </v-carousel-item>
      </v-carousel>
      <p class="platform-label">
        This platform is a recruiter-free environment for independent consultants to connect and share opportunities
      </p>

      <div class="bottom-nav">
        <LoginBtnWithRules
          class="linked-in-wrapper"
          @login="login"
        />
      </div>

      <!-- <v-img
        :src="bgUrl"
        width="100%"
        contain
        class="shape"
      /> -->
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import LoginBtnWithRules from '@/components/core/LoginBtnWithRules.vue'
import { trackNextSlideTap, trackPrevSlideTap } from '@/segmentAnalytics/registration'

@Component({
  components: {
    LoginBtnWithRules
  }
})
export default class LoginSlider extends Vue {
  logoUrl: string = require('@/assets/images/logo.svg')
  linkedInLogo: string = require('@/assets/images/ui/bottom-nav/linked-in-logo.svg')

  items: any = [
    {
      src: require('@/assets/images/login/network.svg'),
      title: 'Sign up for exclusive job opportunities at world-leading organizations',
      body: 'Our members have access to work opportunities from Riverflex clients and partners - you will not find these roles elsewhere.'
    },
    {
      src: require('@/assets/images/login/briefcase-purple.svg'),
      title: 'Get access to our vast professional network',
      body: 'Riverflex Platform hosts 2000+ digital consultants with top-tier industry experience - it’s a great way to grow your professional network & connect with peers.'
    }
  ]

  carouselModel: number = 0

  @Watch('carouselModel')
  onCarouselSliderChange (val: number, oldVal: number) {
    val > oldVal ? trackNextSlideTap(val) : trackPrevSlideTap(val)
  }

  get isLargeDesktop (): boolean {
    return this.$mediaQuery.isLargeDesktop
  }

  // get bgUrl (): string {
  // return this.isLargeDesktop ?
  //   require('@/assets/images/login/login-waves-bg-desktop.svg') :
  //   require('@/assets/images/login/login-waves-bg-mobile.svg')
  // }

  get logoWidth (): number {
    return this.isLargeDesktop ? 248 : 180
  }

  get linkedInLogoWidth (): number {
    return this.isLargeDesktop ? 46 : 30
  }

  get carouselImgWidth (): number {
    return this.isLargeDesktop ? 74 : 55
  }

  get carouselHeight (): number {
    return this.isLargeDesktop ? 350 : 330
  }

  private login () {
    this.$emit('login')
  }
}
</script>

<style lang='scss' scoped>
.logo {
  .media-desktop & {
    margin-top: 18px;
    padding-bottom: 60px !important;
  }
}
.copy {
  color: grey;
}
.slider {
  max-width: 500px;
  margin: 0 auto;
  z-index: 1;
  padding-bottom: 10px;
  
  .media-desktop & {
    max-width: 700px;
    padding-bottom: 15px;
  }

  .media-lg-desktop & {
    max-width: 900px;
    height: auto;
  }
}
.carousel-item__header {
  .media-lg-desktop & {
    margin-top: 32px !important;
    font-size: 36px !important;
  }
}
.carousel-item__body {
  .media-lg-desktop & {
    font-size: 21px !important;
  }
}

.platform-label {
  position: relative;
  max-width: 520px;
  padding: 0 20px;
  margin: 10px auto 0 auto;
  text-align: center;
  font-size: 14px;
  z-index: 1;
  .media-lg-desktop & {
    margin-top: 19px;
    font-size: 20px;
    max-width: 620px;
  }
}
.shape-bg {
  width: 100vw;
}
.bottom-nav {
  position: absolute;
  left: 0;
  bottom: 10px;
  margin: 0 10px;
  border-radius: 12px;
  background-color: var(--v-beige-base);
  width: calc(100% - 20px);
  padding: 10px;

  .media-desktop & {
    padding: 40px;
  }
}
.linked-in-wrapper {
  margin: 0 auto;
  max-width: 306px;
  height: 145px;
  z-index: 1;

  .media-lg-desktop & {
    max-width: 490px;
    height: auto;
  }
}
</style>
